var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAuto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.522949,
    y: 0.570068,
    width: 40,
    height: 40,
    rx: 11.4286,
    fill: "#1A2A6C",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5566 12.2282C16.9025 11.351 18.1439 11.351 18.4898 12.2282L19.5618 14.9463C19.6674 15.2141 19.8794 15.4261 20.1472 15.5317L22.8654 16.6037C23.7425 16.9496 23.7425 18.191 22.8654 18.5369L20.1472 19.6089C19.8794 19.7145 19.6674 19.9265 19.5618 20.1943L18.4898 22.9125C18.1439 23.7896 16.9025 23.7896 16.5566 22.9125L15.4846 20.1943C15.3789 19.9265 15.167 19.7145 14.8992 19.6089L12.181 18.5369C11.3039 18.191 11.3039 16.9496 12.181 16.6037L14.8992 15.5317C15.167 15.4261 15.379 15.2141 15.4846 14.9463L16.5566 12.2282Z",
    stroke: "#1A2A6C",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0117 21.9184C25.1947 21.4543 25.8517 21.4543 26.0347 21.9184L26.8353 23.9484C26.8912 24.0901 27.0034 24.2023 27.1451 24.2582L29.1751 25.0588C29.6392 25.2418 29.6392 25.8988 29.1751 26.0818L27.1451 26.8824C27.0034 26.9383 26.8912 27.0505 26.8353 27.1922L26.0347 29.2222C25.8517 29.6863 25.1947 29.6863 25.0117 29.2222L24.2111 27.1922C24.1552 27.0505 24.043 26.9383 23.9013 26.8824L21.8713 26.0818C21.4072 25.8988 21.4072 25.2418 21.8713 25.0588L23.9013 24.2582C24.043 24.2023 24.1552 24.0901 24.2111 23.9484L25.0117 21.9184Z",
    stroke: "#1A2A6C",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAuto);
export default __webpack_public_path__ + "static/media/icon-auto.c0f645e08b9e1602bd87b8b9b07dd389.svg";
export { ForwardRef as ReactComponent };